import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["columns", "data", "rowSelection", "sortModel", "onSortChange", "mobileHeader", "mobileStyle"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Table/Table.js",
    _this = this;

import React, { useCallback } from 'react';
import Text from '../Text';
import Checkbox from '../Checkbox';
import Radio from '../Radio';
import useSelect from './hooks/useSelect';
import useSorting from './hooks/useSorting';
import useDevice from '../../core/hooks/useDevice';
import SortingUp from '@dls/assets/icons/SortingUp';
import SortingDown from '@dls/assets/icons/SortingDown';
import SortingNeutral from '@dls/assets/icons/SortingNeutral';
import * as SC from './style';
var sortingIcons = {
  asc: /*#__PURE__*/React.createElement(SortingUp, {
    "data-testid": "table-asc-icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 8
    }
  }),
  desc: /*#__PURE__*/React.createElement(SortingDown, {
    "data-testid": "table-desc-icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 9
    }
  }),
  "null": /*#__PURE__*/React.createElement(SortingNeutral, {
    "data-testid": "table-neutral-icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  })
};

var Table = function Table(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      rowSelection = _ref.rowSelection,
      sortModel = _ref.sortModel,
      onSortChange = _ref.onSortChange,
      mobileHeader = _ref.mobileHeader,
      mobileStyle = _ref.mobileStyle,
      rest = _objectWithoutProperties(_ref, _excluded);

  var altStyle = columns.length > 3;

  var _useDevice = useDevice(),
      isMobile = _useDevice.isMobile;

  var _useSelect = useSelect({
    data: data,
    rowSelection: rowSelection
  }),
      onSelect = _useSelect.onSelect,
      onSelectAll = _useSelect.onSelectAll,
      getRecordIndex = _useSelect.getRecordIndex,
      isAllSelected = _useSelect.isAllSelected;

  var _useSorting = useSorting({
    sortModel: sortModel,
    onSortChange: onSortChange,
    columns: columns
  }),
      onSortClick = _useSorting.onSortClick,
      sortingModels = _useSorting.sortingModels;

  var renderColumn = function renderColumn(column, record, index) {
    if (column.render && typeof column.render === 'function') {
      return column.render({
        value: record[column.key],
        record: record,
        index: index
      });
    } else {
      return record[column.key];
    }
  };

  var renderSortingIcon = useCallback(function (columnKey) {
    var _sortingModels$column;

    var sort = ((_sortingModels$column = sortingModels[columnKey]) === null || _sortingModels$column === void 0 ? void 0 : _sortingModels$column.sort) || null;
    return sortingIcons[sort];
  }, [sortingModels]);
  return /*#__PURE__*/React.createElement(SC.TableContainer, {
    "data-testid": rest['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(SC.Table, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("thead", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SC.tr, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 11
    }
  }, (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'checkbox' ? /*#__PURE__*/React.createElement(SC.Headth, {
    width: rowSelection.width,
    styles: rowSelection.style,
    className: "checkbox",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Checkbox.Input, {
    checked: isAllSelected,
    onChange: onSelectAll,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 17
    }
  })) : (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'radio' ? /*#__PURE__*/React.createElement(SC.Headth, {
    width: rowSelection.width,
    styles: rowSelection.style,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 15
    }
  }) : null, !isMobile || !altStyle ? columns.map(function (item) {
    return /*#__PURE__*/React.createElement(SC.Headth, {
      key: 'th-' + item.key,
      alignment: item.alignment,
      width: item.width,
      styles: item.style,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(SC.HeadContent, {
      "data-testid": "table-sortBtn",
      sortable: item.sortable,
      onClick: function onClick() {
        return onSortClick(item);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(Text, {
      type: !isMobile ? 'header' : 'smallBody',
      tag: "span",
      fontWeight: "bold",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 21
      }
    }, item.title), item.sortable ? /*#__PURE__*/React.createElement(SC.SortWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 103,
        columnNumber: 23
      }
    }, /*#__PURE__*/React.createElement(SC.HeadSorter, {
      enableInteraction: item.sortable,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 25
      }
    }, renderSortingIcon(item.key))) : null));
  }) : /*#__PURE__*/React.createElement(SC.Headth, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Text, {
    type: "smallBody",
    tag: "span",
    fontWeight: "bold",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 17
    }
  }, mobileHeader)))), /*#__PURE__*/React.createElement("tbody", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 9
    }
  }, data.map(function (record, index) {
    return /*#__PURE__*/React.createElement(SC.tr, {
      key: 'tr-' + index,
      className: getRecordIndex(record) > -1 ? 'active' : undefined,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 123,
        columnNumber: 13
      }
    }, (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'checkbox' ? /*#__PURE__*/React.createElement(SC.td, {
      width: rowSelection.width,
      styles: rowSelection.style,
      altStyle: altStyle,
      className: "checkbox",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 128,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Checkbox.Input, {
      checked: getRecordIndex(record) > -1,
      onChange: function onChange(e, checked) {
        return onSelect(e, checked, record);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 134,
        columnNumber: 19
      }
    })) : (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'radio' ? /*#__PURE__*/React.createElement(SC.td, {
      width: rowSelection.width,
      styles: rowSelection.style,
      altStyle: altStyle,
      className: (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.type) === 'radio' ? 'radio' : undefined,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 140,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Radio.Input, {
      checked: getRecordIndex(record) > -1,
      onChange: function onChange(e, checked) {
        return onSelect(e, checked, record);
      },
      "data-testid": "radioInputId",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 148,
        columnNumber: 19
      }
    })) : null, !isMobile || !altStyle ? columns.map(function (item) {
      return /*#__PURE__*/React.createElement(SC.td, {
        key: 'td-' + item.key,
        alignment: item.alignment,
        width: item.width,
        styles: item.style,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157,
          columnNumber: 19
        }
      }, /*#__PURE__*/React.createElement(Text, {
        type: !isMobile ? 'body' : 'smallBody',
        tag: "span",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 163,
          columnNumber: 21
        }
      }, renderColumn(item, record, index)));
    }) : /*#__PURE__*/React.createElement(SC.td, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 169,
        columnNumber: 17
      }
    }, columns.map(function (item) {
      return /*#__PURE__*/React.createElement(SC.MobileContainer, {
        key: item.key,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 171,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(SC.MobileTitleTextWrapper, {
        styles: mobileStyle === null || mobileStyle === void 0 ? void 0 : mobileStyle.titleStyle,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 172,
          columnNumber: 23
        }
      }, /*#__PURE__*/React.createElement(Text, {
        type: "smallBody",
        tag: "span",
        fontWeight: "bold",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 175,
          columnNumber: 25
        }
      }, item.title)), /*#__PURE__*/React.createElement(SC.MobileDataTextWrapper, {
        styles: mobileStyle === null || mobileStyle === void 0 ? void 0 : mobileStyle.dataStyle,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 179,
          columnNumber: 23
        }
      }, /*#__PURE__*/React.createElement(Text, {
        type: "smallBody",
        tag: "span",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 180,
          columnNumber: 25
        }
      }, renderColumn(item, record, index))));
    })));
  }))));
};

Table.defaultProps = {
  columns: [],
  data: [],
  sortModel: [],
  onSortChange: function onSortChange() {},
  mobileStyle: {}
};
export default Table;